import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home2'
import Index from '@/components/index2'
import AboutUs from '@/components/aboutUs'
import ContactUs from '@/components/contactUs'
import Solution from '@/components/solution'
import News from '@/components/News2/index'
import NewsDetail from '@/components/News2/newsDetail'
import downLoadCenter from '@/components/downLoadCenter'
import SolutionMore from '@/components/solutionMore'



import JoinUs from '@/components/AboutUs/JoinUs'
import Case from '@/components/Case'
import CaseDetail from '@/components/CaseDetail'


Vue.use(Router)

// 解决菜单栏连续点击跳转报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode:'history',
  // base: '/dist/',
  routes: [
    {
      path: '/',name: '计氏',component: Index,
      children:[
        { path: '/', component: Home, name: '计氏首页' ,meta: {title: '计氏首页'}},
        { path: '/AboutUs', component: AboutUs, name: 'AboutUs' ,meta: {title: '关于我们'} },
        { path: '/Solution', component: Solution, name: 'Solution'  ,meta: {title: '解决方案'}},
        { path: '/ContactUs', component: ContactUs, name: 'ContactUs' ,meta: {title: '联系我们'} },
        { path: '/News', component: News, name: 'News' ,meta: {title: '新闻资讯'} },
        { path: '/News/NewsDetail/:id', component: NewsDetail, name: 'NewsDetail' ,meta: {title: '新闻中心'} },
        { path: '/downLoadCenter', component: downLoadCenter, name: 'downLoadCenter' ,meta: {title: '下载中心'} },
        { path: '/SolutionMore/:id',name: 'SolutionMore', component: SolutionMore,},
        //
        // { path: '/Case/:id', component: CaseDetail, name: '经典案例' },
      ]
    },
  ],


  scrollBehavior (to, from, savedPosition) { // 解决vue页面之间跳转，页面不是在顶部的问题
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js